<template>
<div class="converter-loader">
    <div class="converter-loader__circle" style="animation-delay: 0s" />
    <div class="converter-loader__circle" style="animation-delay: .25s" />
    <div class="converter-loader__circle" style="animation-delay: .5s" />
</div>
</template>

<script>
export default {

}
</script>

<style>
.converter-loader {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 25px;
}

.converter-loader__circle {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: currentColor;
    animation: blink 1s infinite;
    opacity: .25;
}

.converter-loader__circle + .converter-loader__circle {
    margin-left: 20px;
}

@keyframes blink {
    0% {
        opacity: .25;
    }

    50% {
        opacity: 1;
    }

    100% {
        opacity: .25;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Loading.vue